import cn from 'classnames';

import { defineTheme, type ThemeKeys } from 'js/utils/theme-helpers';
import OPE from 'js/on-page-editing';

import { IContentContainer } from 'source/NFR.types';

const themes = defineTheme({
  narrow: 'content-container--theme-narrow',
  medium: 'content-container--theme-medium',
  wide: 'content-container--theme-wide'
});
type ContentContainerTheme = ThemeKeys<typeof themes>;

interface ContentContainerProps extends IContentContainer {
  className?: string;
  element?: keyof JSX.IntrinsicElements;
  theme?: ContentContainerTheme;
}

const ContentContainer: React.FC<React.PropsWithChildren<ContentContainerProps>> = ({
  children,
  className,
  element = 'div',
  theme = 'wide',
  onPageEditing
}) => {
  const Element = element;

  return (
    <Element className={cn('content-container', className, themes(theme))} {...OPE(onPageEditing?.title)}>
      {children}
    </Element>
  );
};

ContentContainer.displayName = 'ContentContainer';

export default ContentContainer;
